var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMalta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "MALTA_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000126293330154003212550000017678371107789279128_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.1912 0.244141H17.4102V19.8232H34.1912V0.244141Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000126293330154003212550000017678371107789279128__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.4099 0.244141H0.628906V19.8232H17.4099V0.244141Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000126293330154003212550000017678371107789279128__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.50757 3.22595C4.50757 3.25595 4.47458 3.28293 4.43158 3.28293C4.38858 3.28293 4.35156 3.25695 4.35156 3.22595C4.35156 3.19495 4.38858 3.16895 4.43158 3.16895C4.47458 3.16895 4.50757 3.19395 4.50757 3.22595Z",
    fill: "#EFECEC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M2.02734 2.95032V4.3923H3.46735C3.46735 4.6313 3.71134 4.87231 3.94934 4.87231V6.3143H5.38837V4.87231C5.62837 4.87231 5.87036 4.6313 5.87036 4.3923H7.31335V2.95032H5.87036C5.87036 2.71032 5.62837 2.47229 5.38837 2.47229V1.0293H3.94934V2.47229C3.71134 2.47229 3.46735 2.71032 3.46735 2.95032H2.02734Z",
    fill: "#D30038"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M2.07617 2.99915V4.34515H3.51721C3.51721 4.58515 3.75715 4.82715 3.99615 4.82715V6.26816H5.34216V4.82715C5.58416 4.82715 5.82416 4.58615 5.82416 4.34515H7.26318V2.99915H5.82416C5.82416 2.75815 5.58416 2.51917 5.34216 2.51917V1.07715H3.99615V2.51917C3.75815 2.51917 3.51721 2.75815 3.51721 2.99915H2.07617Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M2.12305 3.04703V4.29602H3.56604C3.56604 4.53802 3.80409 4.77603 4.04309 4.77603V6.21704H5.29504V4.77603C5.53304 4.77603 5.77704 4.53802 5.77704 4.29602H7.21704V3.04703H5.77704C5.77704 2.80503 5.53304 2.56503 5.29504 2.56503V1.12402H4.04309V2.56503C3.80509 2.56503 3.56604 2.80403 3.56604 3.04703H2.12305Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M2.16992 3.09482V4.24881H3.61292C3.61292 4.48781 3.85093 4.72781 4.09393 4.72781V6.16983H5.24792V4.72781C5.48592 4.72781 5.72693 4.48781 5.72693 4.24881H7.16797V3.09482H5.72693C5.72693 2.85382 5.48692 2.61383 5.24792 2.61383V1.17383H4.09393V2.61383C3.85193 2.61383 3.61292 2.85382 3.61292 3.09482H2.16992Z",
    fill: "#CACACA"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M4.1058 2.49452C4.1898 2.57852 4.12176 2.78553 3.95376 2.95353C3.78376 3.12353 3.57677 3.19154 3.49277 3.10554C3.41077 3.02254 3.4788 2.81653 3.6448 2.64753C3.8158 2.47853 4.0208 2.41152 4.1058 2.49452Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M4.00372 2.59747C4.08772 2.68247 4.06669 2.84149 3.95269 2.95349C3.83969 3.06649 3.68068 3.0895 3.59368 3.0065C3.51168 2.9205 3.53271 2.7605 3.64471 2.6485C3.76171 2.5365 3.91972 2.51347 4.00372 2.59747Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M3.57617 2.85181L3.61316 2.81781L3.74615 2.88681L3.68219 2.74881L3.71521 2.71582L3.85217 2.98682L3.57617 2.85181Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M3.7832 2.64728L3.81616 2.61328L4.01917 2.81827L3.98621 2.85226L3.7832 2.64728Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M5.84604 3.10474C5.76204 3.19074 5.55504 3.12174 5.38504 2.95274C5.21904 2.78474 5.151 2.57772 5.233 2.49372C5.317 2.41072 5.524 2.47674 5.694 2.64674C5.859 2.81574 5.93404 3.02174 5.84604 3.10474Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M5.74387 3.0065C5.65987 3.0895 5.50186 3.06749 5.38486 2.95349C5.27686 2.84249 5.25187 2.68247 5.33787 2.59747C5.42187 2.51347 5.58182 2.5365 5.69382 2.6485C5.80482 2.7605 5.82787 2.9205 5.74387 3.0065Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M5.48956 2.58008L5.52258 2.6131L5.45258 2.74908L5.59155 2.6821L5.62457 2.71609L5.35156 2.85208L5.48956 2.58008Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M5.69324 2.78516L5.72723 2.81815L5.52325 3.02216L5.49023 2.98715L5.69324 2.78516Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M5.23204 4.84953C5.15004 4.76553 5.21801 4.55854 5.38401 4.38954C5.55401 4.22154 5.76101 4.15353 5.84501 4.23653C5.93301 4.32253 5.85903 4.52755 5.69303 4.69655C5.52303 4.86455 5.31604 4.93253 5.23204 4.84953Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M5.33787 4.74571C5.25187 4.66071 5.27686 4.50271 5.38486 4.38871C5.50186 4.27671 5.65987 4.25372 5.74387 4.33772C5.82787 4.42272 5.80485 4.58171 5.69285 4.69471C5.58185 4.80871 5.42187 4.83071 5.33787 4.74571Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M5.76227 4.49246L5.72723 4.52444L5.59222 4.45645L5.66022 4.59344L5.62524 4.62646L5.49023 4.35547L5.76227 4.49246Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M5.5553 4.69519L5.52332 4.72818L5.32031 4.52417L5.35229 4.49219L5.5553 4.69519Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M3.49162 4.23555C3.57562 4.15255 3.78262 4.22056 3.95262 4.38856C4.12062 4.55756 4.1886 4.76456 4.1046 4.84856C4.0206 4.93156 3.8156 4.86457 3.6436 4.69557C3.4786 4.52657 3.40962 4.32155 3.49162 4.23555Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_22"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M3.59368 4.33772C3.68168 4.25372 3.83969 4.27671 3.95269 4.38871C4.06569 4.50271 4.08772 4.66071 4.00372 4.74571C3.91972 4.83071 3.76171 4.80871 3.64471 4.69471C3.53271 4.58171 3.51168 4.42272 3.59368 4.33772Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_23"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M3.85181 4.76318L3.8158 4.72818L3.88483 4.59317L3.74579 4.66119L3.71484 4.62619L3.98584 4.49219L3.85181 4.76318Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M3.64429 4.55927L3.61328 4.52426L3.81628 4.32129L3.85229 4.35529L3.64429 4.55927Z",
    fill: "#CECECE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_25"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M4.67236 4.69031C4.10936 4.69031 3.65234 4.23232 3.65234 3.67032C3.65234 3.11032 4.10936 2.6543 4.67236 2.6543C4.94436 2.6543 5.19734 2.75729 5.38934 2.95129C5.58234 3.14229 5.68634 3.39932 5.68634 3.67032C5.68634 3.94232 5.58234 4.19732 5.38934 4.39032C5.19734 4.58432 4.94336 4.69031 4.67236 4.69031ZM4.67236 2.6713C4.11736 2.6713 3.67035 3.1193 3.67035 3.6713C3.67035 4.2243 4.11736 4.6723 4.67236 4.6723C4.94036 4.6723 5.19039 4.56932 5.37939 4.38132C5.56739 4.19032 5.67236 3.9403 5.67236 3.6713C5.67236 3.4053 5.56739 3.15332 5.37939 2.96332C5.19039 2.77432 4.94036 2.6713 4.67236 2.6713Z",
    fill: "#91857C"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_26"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M4.67163 4.44849C4.24363 4.44849 3.89062 4.09948 3.89062 3.67148C3.89062 3.24348 4.24363 2.89648 4.67163 2.89648C5.09963 2.89648 5.44666 3.24348 5.44666 3.67148C5.44666 4.09948 5.09963 4.44849 4.67163 4.44849ZM4.67163 2.91049C4.24963 2.91049 3.90961 3.25248 3.90961 3.67148C3.90961 4.09248 4.24963 4.4335 4.67163 4.4335C5.08763 4.4335 5.42963 4.09248 5.42963 3.67148C5.42963 3.25248 5.08763 2.91049 4.67163 2.91049Z",
    fill: "#91857C"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_27"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M4.33429 4.4882C4.33429 4.5062 4.32433 4.52119 4.30933 4.53019C4.29333 4.53919 4.27633 4.53919 4.26233 4.53019C4.24633 4.52119 4.2373 4.5062 4.2373 4.4882C4.2373 4.4702 4.24733 4.45518 4.26233 4.44718C4.27633 4.43818 4.29333 4.43818 4.30933 4.44718C4.32433 4.45518 4.33429 4.4712 4.33429 4.4882Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_28"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M5.10187 4.4882C5.10187 4.5062 5.0919 4.52119 5.0799 4.53019C5.0619 4.53919 5.04487 4.53919 5.02887 4.53019C5.01487 4.52119 5.00391 4.5062 5.00391 4.4882C5.00391 4.4702 5.01587 4.45518 5.02887 4.44718C5.04487 4.43818 5.0619 4.43818 5.0799 4.44718C5.0919 4.45518 5.10187 4.4712 5.10187 4.4882Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_29"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M4.63886 4.48792V4.53791H4.57489C4.50889 4.53791 4.50889 4.5889 4.57489 4.5889H4.63886V4.63792C4.63886 4.69092 4.69388 4.69791 4.69788 4.64191L4.70386 4.5889H4.76691C4.83091 4.5889 4.83091 4.53791 4.76691 4.53791H4.70386V4.48792C4.70286 4.43892 4.63886 4.43892 4.63886 4.48792Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M5.21875 3.81918C5.23675 3.81318 5.26178 3.81618 5.26178 3.81618C5.26178 3.81618 5.26575 3.82918 5.25775 3.83318C5.26575 3.83818 5.29474 3.83718 5.29474 3.83718C5.29474 3.83718 5.28273 3.84517 5.27673 3.84817C5.28673 3.85017 5.29974 3.86419 5.29974 3.86419C5.29974 3.86419 5.27674 3.86817 5.26874 3.86217C5.27274 3.87617 5.27277 3.88717 5.27277 3.88717C5.27277 3.88717 5.23177 3.87618 5.21777 3.85018L5.21875 3.81918Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_31"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask30_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M5.15222 3.79636C5.14222 3.81936 5.07422 3.77637 5.07422 3.77637C5.07422 3.77637 5.10127 3.82435 5.15027 3.83035L5.15222 3.79636Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M4.27881 4.24484H5.09979L5.15979 4.19586L5.05481 4.13885L4.89282 4.08386L4.82782 4.04785L4.70679 4.05484L4.60583 4.10684L4.46881 4.12283L4.43481 4.16086L4.3338 4.16986L4.17383 4.16583L4.43982 4.20786L4.21881 4.19684L4.27881 4.24484Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_33"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M5.09985 4.24896H4.27991L4.21985 4.19998L4.44489 4.20398L4.17487 4.16998L4.43689 4.15698L4.46588 4.12198L4.60687 4.10196L4.70789 4.04996L4.82886 4.04297L4.89685 4.07797L5.16486 4.19098L5.09985 4.24896ZM4.21887 4.20096L4.27887 4.24298L5.09485 4.24197L5.15985 4.19196L4.82788 4.04996L4.70685 4.05698L4.60889 4.10995L4.4679 4.12698L4.4389 4.16397L4.33289 4.17096L4.17285 4.16898L4.44287 4.20297L4.21887 4.20096Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_34"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M4.72302 4.01126C4.61702 3.95426 4.58802 4.09126 4.54102 4.12326C4.60202 4.13426 4.64597 4.07827 4.69897 4.05127C4.73597 4.15627 4.797 4.08627 4.797 4.08627C4.797 4.08627 4.86002 4.18827 4.94702 4.14227C4.97202 4.16027 4.99402 4.14429 4.99402 4.14429C4.99402 4.14429 5.02702 4.14928 5.03302 4.13428C5.04902 4.14128 5.06598 4.12027 5.06598 4.12027C5.06598 4.12027 5.10101 4.12226 5.10901 4.10226C5.16001 4.11126 5.22998 3.99527 5.22998 3.99527L5.25098 3.95428L5.28198 3.94827C5.28198 3.94827 5.28201 3.92826 5.26801 3.92926C5.26801 3.91526 5.25598 3.90929 5.24298 3.91129C5.24298 3.90429 5.23102 3.89828 5.23102 3.89828C5.20202 3.90628 5.20203 3.98029 5.20203 3.98029C5.20203 3.98029 5.15097 4.01927 5.13397 4.02927C5.13397 3.98527 5.06203 3.92828 5.07703 3.90128C5.09103 3.87528 5.13802 3.94427 5.17902 3.93127C5.21802 3.91827 5.23901 3.86627 5.23901 3.82727C5.22501 3.79827 5.20001 3.75327 5.20001 3.75327L5.17499 3.75027L5.15198 3.69629C5.15198 3.69629 5.10098 3.72627 5.10498 3.75427C5.10498 3.78127 5.15601 3.80426 5.15601 3.80426C5.15601 3.80426 5.129 3.82327 5.099 3.81427C5.095 3.84327 5.13 3.83728 5.146 3.83728C5.152 3.85628 5.17102 3.86829 5.17102 3.86829C5.17102 3.86829 5.181 3.89829 5.151 3.89429C5.12 3.89329 5.07901 3.81927 5.03601 3.85327C4.98901 3.88827 5.05701 3.95328 5.05701 3.95328C5.05701 3.95328 5.01801 3.97429 4.98901 4.03229C4.89301 3.94729 4.83402 3.98626 4.72302 4.01126Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_35"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M4.90167 4.15738C4.84167 4.15738 4.79968 4.10037 4.79468 4.09137C4.79468 4.10237 4.72672 4.13138 4.69672 4.05338C4.68472 4.06338 4.6717 4.07438 4.6557 4.08438C4.6247 4.10638 4.59468 4.13138 4.55768 4.13138C4.55368 4.12738 4.55371 4.12537 4.55371 4.12537C4.59471 4.11737 4.62371 4.09736 4.64771 4.07736C4.66771 4.06636 4.68072 4.05637 4.69672 4.04837C4.73572 4.12737 4.79468 4.08438 4.79468 4.08438C4.80068 4.08538 4.87472 4.17736 4.94672 4.13736L4.99768 4.13937L5.03668 4.13235C5.06568 4.11535 5.09968 4.11538 5.10468 4.10138C5.16368 4.10038 5.22571 3.99536 5.22571 3.99536L5.25067 3.95337L5.24268 3.95535L5.23871 3.91235C5.21371 3.90835 5.20569 3.96236 5.20569 3.98236C5.20169 3.98536 5.15467 4.02436 5.13367 4.03436C5.12767 4.01236 5.11169 3.98738 5.09869 3.96738C5.07869 3.94238 5.06167 3.91837 5.07367 3.90237L5.12067 3.90936C5.13467 3.92136 5.14972 3.93137 5.16772 3.93137C5.21072 3.91737 5.23172 3.87037 5.23572 3.82837C5.22572 3.80637 5.20668 3.77238 5.20068 3.76038C5.21868 3.77638 5.23571 3.80638 5.24371 3.82538C5.24371 3.87238 5.21869 3.92537 5.17969 3.93637C5.15069 3.93537 5.13071 3.92535 5.11371 3.91635C5.07471 3.91735 5.08871 3.93936 5.10571 3.96136C5.12171 3.98536 5.13867 4.01037 5.13867 4.03137C5.15067 4.01737 5.20172 3.97836 5.20172 3.97836C5.20172 3.97236 5.20167 3.90336 5.23267 3.89636L5.26971 3.92737L5.23267 3.99835C5.23267 4.00335 5.16871 4.10736 5.11371 4.10736C5.10571 4.12336 5.07071 4.12436 5.06671 4.12436L5.00769 4.14838L4.94769 4.14136V4.14636C4.93469 4.15536 4.91767 4.15738 4.90167 4.15738ZM4.55469 4.11536C4.55869 4.10236 4.56668 4.08836 4.57568 4.07336C4.60868 4.02336 4.65172 3.96935 4.72272 4.00735L4.77771 3.99435C4.85971 3.97235 4.92269 3.96736 4.99469 4.03036C5.01269 3.97736 5.05173 3.95436 5.05573 3.95236C5.05173 3.95236 5.01669 3.91637 5.02069 3.88437L5.06372 3.84238C5.08172 3.84238 5.10271 3.85736 5.11871 3.87036C5.13271 3.88136 5.14369 3.89337 5.15369 3.89337C5.16969 3.87337 5.15168 3.86236 5.14368 3.84436L5.1767 3.86737L5.15167 3.90036C5.13967 3.89936 5.13069 3.88836 5.11469 3.87836C5.09669 3.86436 5.08172 3.85037 5.06372 3.85037L5.02869 3.88437C5.02469 3.91537 5.06372 3.95236 5.06372 3.95236C5.05972 3.96036 5.02072 3.98137 4.99872 4.03537C4.91472 3.97637 4.85971 3.98037 4.77771 4.00137L4.72272 4.01337C4.64272 3.97837 4.61371 4.03237 4.57971 4.07837C4.57371 4.09337 4.56569 4.10636 4.55469 4.11536ZM5.12872 3.82037L5.14972 3.80737C5.13772 3.80337 5.10071 3.78036 5.10071 3.75436C5.09871 3.72636 5.14972 3.69336 5.14972 3.69336L5.15967 3.70837L5.14972 3.69736C5.14172 3.70736 5.1087 3.73336 5.1087 3.75436C5.1087 3.77436 5.1417 3.79335 5.1557 3.80035C5.1557 3.80335 5.1557 3.80435 5.1557 3.80435L5.15167 3.80838V3.80737C5.14967 3.81437 5.13872 3.81937 5.12872 3.82037Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_36"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M4.56992 3.86489C4.61292 3.90489 4.58393 3.97191 4.60093 3.98391C4.61693 3.99791 4.64195 3.97689 4.64195 3.97689C4.68895 3.98989 4.76493 3.96389 4.76493 3.96389C4.79993 3.98389 4.7859 3.95288 4.8079 3.95488C4.8279 4.00388 4.88792 3.99389 4.88792 3.99389C4.88792 3.99389 4.83294 3.93491 4.79594 3.91991C4.76894 3.93591 4.68892 3.9389 4.67692 3.9359C4.65992 3.9339 4.67094 3.9149 4.66294 3.9049C4.69194 3.8759 4.67092 3.80389 4.65092 3.77889C4.59192 3.73489 4.51192 3.80989 4.56992 3.86489Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_37"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask36_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M4.87913 4.00036C4.85613 4.00036 4.82009 3.99437 4.80509 3.95837C4.76609 3.96937 4.7151 3.98437 4.6721 3.98437L4.61711 3.99435L4.59208 3.95037C4.59608 3.92437 4.59608 3.89235 4.57108 3.86935C4.54808 3.84935 4.54207 3.82434 4.54807 3.80434C4.56807 3.76534 4.61808 3.75037 4.65708 3.77737C4.67608 3.80837 4.69811 3.88035 4.66911 3.90835C4.72411 3.93535 4.77812 3.93036 4.79612 3.91836C4.83512 3.93636 4.89408 3.99235 4.89408 3.99535L4.87913 4.00036ZM4.80912 3.95235C4.82912 3.98635 4.86013 3.99135 4.87913 3.99135V3.99535L4.88908 3.99135C4.87908 3.99135 4.82808 3.93937 4.79508 3.92437C4.77708 3.93937 4.72309 3.94335 4.69309 3.94335L4.66007 3.90237C4.68907 3.87637 4.66411 3.80535 4.64811 3.78335C4.62111 3.76335 4.57008 3.77436 4.55808 3.80636C4.54608 3.82436 4.55409 3.84637 4.57609 3.86437C4.60109 3.88937 4.59812 3.92435 4.59812 3.95135L4.61711 3.99135L4.6381 3.97637C4.7141 3.97437 4.76512 3.96035 4.76512 3.96035L4.80912 3.95235Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_38"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M4.29138 3.74485C4.23638 3.75985 4.14436 3.67887 4.10236 3.70887C4.05936 3.74087 4.07739 3.81887 4.10639 3.85887C4.13539 3.89687 4.07136 3.90985 4.04736 3.93385C4.02936 3.95385 4.05536 3.97987 4.05536 3.97987L4.07337 3.99086L4.07135 4.02186L4.08136 4.05485C4.08136 4.05485 4.08934 4.06387 4.09534 4.05287C4.10334 4.06187 4.09535 4.08585 4.11835 4.08985C4.11035 4.07385 4.12439 4.02986 4.12439 4.02986C4.12439 4.02986 4.16134 4.03187 4.17334 4.01387C4.18334 3.99687 4.16138 3.95985 4.16138 3.95985H4.17535C4.16135 3.95285 4.15735 3.92585 4.15735 3.92585C4.15735 3.92585 4.20837 3.90785 4.20837 3.86885C4.20837 3.82785 4.12238 3.78387 4.15338 3.76387C4.18638 3.74087 4.24739 3.82386 4.30139 3.78486C4.35239 3.74786 4.32135 3.78486 4.32135 3.78486C4.32135 3.78486 4.34438 3.73185 4.29138 3.74485Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_39"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M4.12259 4.09673L4.10861 4.09374L4.06961 4.02276L4.07162 4.02075L4.10861 4.07974C4.10861 4.05974 4.1166 4.03276 4.1166 4.02776C4.1436 4.02576 4.16363 4.02075 4.16763 4.01275C4.17363 4.00075 4.16361 3.97375 4.15561 3.96475L4.15158 3.92175C4.15158 3.92175 4.2026 3.90574 4.2026 3.86974C4.2026 3.85174 4.1846 3.83376 4.1716 3.81576C4.1516 3.79976 4.1426 3.78676 4.1426 3.77276C4.1526 3.76976 4.16063 3.76676 4.16763 3.76476C4.14763 3.78276 4.16361 3.79575 4.17361 3.81075C4.19361 3.82875 4.2106 3.84674 4.2106 3.86974C4.2106 3.91074 4.15561 3.92974 4.15561 3.92974C4.16761 3.96474 4.18461 3.99975 4.17361 4.01775C4.16761 4.03175 4.14261 4.03375 4.12661 4.03375C4.12261 4.04475 4.11257 4.07774 4.12057 4.08874L4.12259 4.09673ZM4.06259 3.98574L4.05062 3.98376C4.04262 3.97076 4.02963 3.94774 4.04263 3.92974C4.09163 3.89974 4.10561 3.89175 4.10861 3.87875C4.08761 3.84075 4.07562 3.80776 4.07162 3.78076C4.06962 3.74676 4.07958 3.72074 4.09658 3.70474C4.14758 3.69674 4.17257 3.70876 4.19857 3.72076C4.22757 3.73176 4.25359 3.74175 4.27859 3.74175L4.32357 3.74474L4.31161 3.76675L4.27859 3.75076C4.25359 3.75076 4.22357 3.73774 4.19857 3.72674C4.17357 3.71574 4.14361 3.70474 4.12661 3.70474C4.07961 3.72774 4.07962 3.75774 4.07962 3.77874C4.08362 3.80574 4.09361 3.83576 4.10861 3.85476C4.11261 3.89576 4.09259 3.90573 4.07559 3.91573C4.03659 3.95273 4.05758 3.97476 4.05758 3.97576L4.06259 3.98574Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_40"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M4.56591 3.17944C4.49391 3.14744 4.34691 3.14747 4.26891 3.10547C4.23191 3.10947 4.21792 3.13646 4.21392 3.14746C4.17692 3.14546 4.15094 3.20546 4.15594 3.21646C4.08794 3.18846 4.05795 3.29444 4.07995 3.31744C4.02095 3.32044 4.02896 3.39446 4.02496 3.41446C4.00696 3.46046 4.02891 3.47545 4.06591 3.46045C4.06991 3.47845 4.06195 3.48846 4.04595 3.49246C4.14395 3.60746 4.20191 3.42245 4.28991 3.42245C4.39691 3.39145 4.44195 3.33746 4.44195 3.33746L4.48492 3.34247L4.56591 3.17944Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_41"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M4.10849 3.53354C4.08749 3.53354 4.06951 3.51954 4.04251 3.49554L4.01846 3.45956C4.01046 3.44856 4.01047 3.43254 4.02047 3.41254C4.02447 3.36654 4.02849 3.31556 4.07949 3.31256C4.06949 3.30756 4.06947 3.28056 4.07547 3.25256C4.09147 3.22456 4.10845 3.20354 4.13845 3.20554C4.15245 3.20554 4.15651 3.18754 4.16751 3.17554C4.17351 3.16254 4.1885 3.14154 4.2145 3.14154C4.2105 3.13254 4.2285 3.10354 4.2695 3.10254C4.3125 3.12354 4.37745 3.13255 4.43545 3.14355C4.48645 3.15155 4.53349 3.15955 4.56649 3.17355L4.49051 3.34354L4.44345 3.34055C4.44545 3.34055 4.40247 3.39354 4.29147 3.42554C4.26247 3.42554 4.23249 3.45356 4.19949 3.48056C4.17349 3.50556 4.14349 3.53354 4.10849 3.53354ZM4.02847 3.45154L4.06949 3.45554L4.04647 3.49655C4.10547 3.53955 4.14849 3.51855 4.19449 3.47455C4.22349 3.44655 4.25349 3.41754 4.29049 3.41754C4.39349 3.38754 4.4385 3.33255 4.4385 3.33255L4.4855 3.33856L4.56149 3.17654C4.52849 3.16854 4.48548 3.15956 4.43448 3.15256C4.37448 3.14256 4.31149 3.13153 4.26449 3.11053C4.23549 3.11353 4.2175 3.13855 4.2175 3.14755C4.1925 3.15255 4.17645 3.17255 4.17245 3.18155L4.17648 3.19156L4.15548 3.21954C4.11648 3.21654 4.09246 3.23154 4.08346 3.25754C4.07546 3.28054 4.07546 3.30656 4.08346 3.31656C4.04046 3.32556 4.0325 3.36855 4.0325 3.39755L4.0245 3.45554L4.02847 3.45154Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_42"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M4.76178 3.09526C4.76178 3.15426 4.71474 3.20027 4.65674 3.20027C4.59774 3.20027 4.55078 3.15326 4.55078 3.09526C4.55078 3.03826 4.59774 2.99025 4.65674 2.99025C4.71474 2.98925 4.76178 3.03826 4.76178 3.09526Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_43"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask42_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M4.65588 3.20416C4.59688 3.20416 4.54688 3.15515 4.54688 3.09515C4.54688 2.97515 4.76587 2.97515 4.76587 3.09515C4.76587 3.15515 4.71888 3.20416 4.65588 3.20416ZM4.65588 2.99414C4.60088 2.99414 4.55389 3.04015 4.55389 3.09515C4.55389 3.20615 4.75287 3.20615 4.75287 3.09515C4.75387 3.04015 4.71488 2.99414 4.65588 2.99414Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_44"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M4.47302 3.92111C4.40702 3.90711 4.29702 3.84212 4.29102 3.75412C4.34802 3.51612 4.66003 3.64012 4.68903 3.46112C4.68103 3.34412 4.70298 3.22811 4.76898 3.12811C4.79598 3.08911 4.83698 3.07812 4.83698 3.07812C4.83698 3.07812 4.84501 3.10313 4.83301 3.12213C4.88401 3.11413 4.95599 3.14312 5.00299 3.14612C5.01899 3.17512 5.01901 3.18713 5.01501 3.20413C5.01101 3.22313 4.98999 3.21613 4.98999 3.21613C4.97799 3.22913 4.96503 3.24112 4.93103 3.23712C4.90603 3.25412 4.84698 3.26013 4.84698 3.26013C4.84698 3.26013 4.96402 3.38011 4.94702 3.41611C4.96802 3.42711 5.00403 3.47913 5.00403 3.47913C5.00403 3.47913 5.08002 3.43812 5.10602 3.40112C5.15102 3.40112 5.22702 3.44912 5.26202 3.45312C5.30502 3.49013 5.34998 3.52713 5.34998 3.52713C5.34998 3.52713 5.29499 3.56111 5.27399 3.51611C5.24499 3.51611 5.18599 3.45112 5.10199 3.46912C5.09999 3.54412 5.01599 3.59711 5.01599 3.59711C5.01599 3.59711 5.09201 3.58712 5.13501 3.61212C5.18001 3.64912 5.24402 3.69913 5.24402 3.69913L5.29901 3.79514C5.29901 3.79514 5.24799 3.80612 5.22699 3.73712C5.20699 3.79212 5.20698 3.70412 5.13098 3.66412C5.10598 3.66512 5.09597 3.66913 5.07397 3.65213C5.01897 3.66813 4.953 3.69912 4.875 3.69012C4.82 3.70812 4.77902 3.75412 4.72302 3.78012C4.66802 3.80512 4.64899 3.79211 4.64899 3.79211L4.60602 3.79413C4.59802 3.82313 4.60203 3.86412 4.57703 3.87112C4.59303 3.88912 4.56702 3.96111 4.53802 3.97311C4.54802 4.02211 4.58899 4.03611 4.62799 4.05911C4.62799 4.05911 4.66498 4.04212 4.69098 4.06412C4.71198 4.08612 4.73401 4.14511 4.73401 4.14511C4.73401 4.14511 4.68697 4.14812 4.67297 4.14212C4.65697 4.13412 4.65301 4.11911 4.64001 4.12411C4.52701 4.02512 4.47001 4.06412 4.45801 4.04312C4.44501 4.01812 4.48202 3.95811 4.47302 3.92111Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_45"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask44_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M4.70715 4.14819L4.67218 4.14319C4.55918 4.06019 4.50815 4.05617 4.48315 4.05417C4.47515 4.04917 4.47318 4.04519 4.46918 4.04019C4.51618 4.04819 4.56716 4.05419 4.63916 4.11819L4.70715 4.14218L4.73218 4.13718C4.72818 4.13518 4.7142 4.09917 4.6972 4.07617C4.7262 4.10517 4.73621 4.1372 4.73621 4.1402L4.70715 4.14819ZM4.68219 4.06619L4.62518 4.06018C4.57618 4.03218 4.5452 4.01418 4.5332 3.97318C4.5512 3.96018 4.57017 3.92818 4.57617 3.90118V3.89917C4.57017 3.94217 4.55517 3.96719 4.53717 3.97519C4.55117 4.00919 4.58016 4.02518 4.61316 4.04318L4.65619 4.04718C4.66819 4.05418 4.67619 4.06019 4.68219 4.06619ZM4.46118 4.03119C4.45318 4.01719 4.45718 4.00517 4.46118 3.99017C4.46918 3.96717 4.47518 3.94017 4.46918 3.92117C4.39918 3.91117 4.2932 3.84218 4.2832 3.75418C4.3162 3.62218 4.42217 3.59917 4.51917 3.57617C4.59717 3.55717 4.67118 3.54218 4.68518 3.46118C4.67718 3.33118 4.7032 3.21819 4.7652 3.12619C4.7962 3.08619 4.83316 3.0772 4.83716 3.0752C4.84116 3.0772 4.84515 3.08917 4.84515 3.10217L4.83716 3.07819V3.08218C4.83716 3.08218 4.80016 3.09318 4.77216 3.12918C4.70916 3.22118 4.6842 3.33218 4.6922 3.46118C4.6762 3.54818 4.60019 3.5662 4.51819 3.5842C4.42619 3.6062 4.32316 3.63018 4.29016 3.75418C4.30016 3.83718 4.40118 3.90317 4.47418 3.91617C4.48218 3.94017 4.4742 3.96718 4.4682 3.99118C4.4652 4.00718 4.46118 4.02219 4.46118 4.03119ZM4.66418 3.79919L4.63116 3.79718L4.64819 3.78717C4.67519 3.79117 4.69317 3.78918 4.72217 3.77618C4.74317 3.76318 4.76916 3.74818 4.79016 3.73218C4.81516 3.71418 4.84121 3.69518 4.87421 3.68518C4.94821 3.68818 4.99317 3.67218 5.03217 3.65918L5.07318 3.64719L5.13019 3.65918C5.16319 3.67518 5.18118 3.69918 5.19318 3.71918C5.17118 3.69918 5.15617 3.68017 5.12817 3.66617L5.07318 3.65018L5.07721 3.65417L5.03619 3.66818C4.99719 3.68018 4.94818 3.69318 4.90118 3.69318C4.84418 3.70218 4.82319 3.7202 4.79419 3.7392C4.77219 3.7552 4.7492 3.77019 4.7262 3.78119C4.6992 3.79319 4.68218 3.79919 4.66418 3.79919ZM5.28717 3.79419C5.26917 3.79419 5.25221 3.78719 5.23621 3.76819C5.26121 3.78919 5.28317 3.79117 5.29517 3.79117L5.24017 3.7002C5.24017 3.7002 5.17619 3.65117 5.13519 3.61517C5.11019 3.60217 5.07818 3.59818 5.05518 3.59818C5.05118 3.59818 5.04919 3.59717 5.04919 3.59717C5.08819 3.59217 5.11716 3.59618 5.13916 3.60718C5.18016 3.64418 5.2442 3.69418 5.2442 3.69418L5.30121 3.79218C5.29921 3.79418 5.29117 3.79419 5.28717 3.79419ZM5.04919 3.58017C5.05919 3.55717 5.09619 3.51818 5.09619 3.46918C5.17619 3.46318 5.20718 3.48119 5.23718 3.49619L5.27417 3.51617V3.51019L5.3092 3.53418L5.25818 3.45517C5.24418 3.45417 5.22318 3.44419 5.19818 3.43219C5.16918 3.41819 5.1322 3.40518 5.1062 3.40518C5.0842 3.44018 5.00821 3.48017 5.00421 3.48117C5.00021 3.48017 4.96515 3.43018 4.94415 3.41818C4.95415 3.38618 4.87921 3.29418 4.84821 3.26218C4.85221 3.25518 4.90716 3.25018 4.92816 3.23318C4.96916 3.23718 4.97921 3.22518 4.99121 3.21518C5.01621 3.18818 5.01616 3.17717 5.00116 3.14917C4.98716 3.15217 4.95816 3.14418 4.93616 3.13818C4.90716 3.13118 4.87921 3.12418 4.84821 3.12418V3.12219C4.88521 3.11819 4.91119 3.1242 4.94019 3.1312C4.96119 3.1362 4.98721 3.14218 5.00421 3.14218C5.02321 3.17618 5.0232 3.18818 5.0202 3.20618C4.9832 3.23118 4.97318 3.24219 4.94818 3.24219C4.90718 3.25819 4.85217 3.26318 4.85217 3.26318C4.86417 3.26918 4.96918 3.38018 4.94818 3.41718C4.97318 3.42218 5.00519 3.47117 5.00519 3.47717C5.00919 3.47217 5.08121 3.43317 5.10321 3.39917C5.13221 3.40117 5.16919 3.41119 5.20319 3.42719C5.22519 3.43719 5.24616 3.44719 5.26416 3.44919L5.35419 3.52219C5.35219 3.53619 5.28916 3.5532 5.27216 3.5152C5.26416 3.5182 5.25517 3.5112 5.23517 3.5022C5.20617 3.4882 5.17421 3.46817 5.13721 3.46817C5.11321 3.51917 5.07419 3.55817 5.04919 3.58017Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_46"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask45_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M4.2073 3.48331C4.2153 3.47631 4.25436 3.4913 4.25436 3.4913L4.32632 3.5383L4.47433 3.63431L4.52933 3.71231L4.43533 3.6813L4.30032 3.5683L4.23233 3.5213C4.23233 3.5213 4.1993 3.49131 4.2073 3.48331Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_47"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask46_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M4.54084 3.71977L4.43482 3.68477L4.22785 3.52476C4.21785 3.51176 4.19483 3.48976 4.20283 3.48076C4.22783 3.47876 4.25385 3.48776 4.25385 3.48976L4.47883 3.63078L4.54084 3.71977ZM4.21485 3.48076L4.21083 3.48576L4.4358 3.67778L4.51985 3.70277L4.4748 3.63676L4.21485 3.48076Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_48"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M5.09204 3.72929C5.04104 3.71629 4.91406 3.87029 4.91406 3.87029L5.00806 3.97429C5.00806 3.97429 5.01204 3.79629 5.09204 3.72929Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_49"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask48_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M5.01221 3.98462L4.91016 3.8736C4.91416 3.8616 5.02917 3.72461 5.08417 3.72461C5.08417 3.72561 5.0842 3.72861 5.0802 3.72861C5.0232 3.74361 4.91821 3.8726 4.91821 3.8736L5.00421 3.96561C5.00421 3.93261 5.01617 3.82362 5.06317 3.75662C5.01617 3.83862 5.01221 3.97261 5.01221 3.97461V3.98462Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_50"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask49_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M4.46451 3.29673C4.43551 3.33473 4.43147 3.40575 4.46847 3.43675C4.47247 3.48075 4.50747 3.56975 4.53647 3.57875C4.56947 3.58775 4.69848 3.61774 4.74948 3.60774C4.73948 3.69074 4.80446 3.75575 4.86246 3.79875C4.86246 3.80575 4.86245 3.81473 4.87045 3.82273C4.87845 3.83273 4.90545 3.83375 4.90945 3.82875C4.92545 3.84775 4.9895 3.85573 4.9935 3.84773C4.9995 3.84173 4.89548 3.76874 4.87448 3.74574C4.85148 3.70974 4.8155 3.62873 4.8085 3.56373C4.7575 3.50373 4.67148 3.50373 4.67148 3.50373L4.67551 3.38673L4.67746 3.25175L4.63046 3.22874C4.63046 3.22874 4.64245 3.22473 4.64645 3.21873C4.65645 3.22473 4.67749 3.20074 4.68149 3.19474C4.69349 3.19974 4.70346 3.19974 4.70346 3.19374C4.70746 3.18774 4.70748 3.16475 4.71548 3.15275C4.74848 3.12275 4.7075 3.05572 4.6525 3.05372C4.5975 3.05272 4.58847 3.11772 4.58847 3.12272C4.59647 3.14372 4.59247 3.15373 4.58847 3.15773C4.58447 3.16373 4.56747 3.17573 4.56747 3.17573C4.56747 3.17573 4.53449 3.16173 4.50149 3.17573C4.46649 3.18973 4.42346 3.20874 4.41946 3.23274C4.40346 3.23574 4.37647 3.25473 4.37247 3.27473C4.35647 3.27273 4.33949 3.28374 4.30649 3.33574C4.24749 3.36074 4.24747 3.48072 4.24747 3.48072C4.24747 3.48072 4.23349 3.50274 4.23349 3.51374C4.22949 3.52674 4.23745 3.53674 4.24545 3.53474C4.24545 3.54274 4.25549 3.55073 4.25949 3.54673C4.26349 3.55473 4.27549 3.56075 4.28049 3.55775C4.28049 3.56375 4.29848 3.56275 4.30148 3.55775C4.30148 3.55275 4.29748 3.52573 4.30148 3.52473C4.30548 3.52173 4.32151 3.53573 4.32651 3.53273C4.33051 3.52873 4.32649 3.51674 4.32449 3.51274C4.32049 3.50774 4.30448 3.50372 4.30148 3.48472C4.29748 3.46572 4.31351 3.43873 4.31351 3.43873C4.31351 3.43873 4.37651 3.39174 4.37851 3.34974C4.42351 3.35374 4.44851 3.31273 4.46451 3.29673Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_51"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask50_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M4.97913 3.85574C4.96113 3.85574 4.9191 3.84876 4.9071 3.83276C4.9281 3.84176 4.96213 3.84775 4.97913 3.84775V3.85275L4.99115 3.84576C4.99115 3.84176 4.9481 3.80976 4.9231 3.78876C4.9001 3.77176 4.88013 3.75776 4.87213 3.74976C4.86413 3.73676 4.81715 3.64377 4.80615 3.56577C4.75915 3.51077 4.6771 3.50876 4.6731 3.50876V3.38675L4.67712 3.25177L4.62811 3.23376L4.63214 3.22876L4.7121 3.15076C4.7241 3.13876 4.72809 3.12377 4.72009 3.10477C4.71209 3.08377 4.68714 3.05875 4.65314 3.05875C4.63614 3.05875 4.62214 3.06474 4.61414 3.07574C4.59614 3.09374 4.59314 3.11874 4.59314 3.12274L4.56415 3.17975L4.5011 3.17575V3.17975C4.4701 3.19175 4.4251 3.21076 4.4231 3.23376C4.4031 3.23876 4.3781 3.25876 4.3761 3.27576C4.3531 3.27876 4.33112 3.29776 4.31012 3.33676C4.25512 3.36076 4.2511 3.47775 4.2511 3.47775L4.24713 3.50076V3.47977H4.24512C4.24512 3.47577 4.24712 3.35676 4.30212 3.33176C4.32712 3.28976 4.3491 3.27075 4.3681 3.27075C4.3721 3.25275 4.39913 3.23277 4.41913 3.22977C4.41913 3.20777 4.46213 3.18777 4.49713 3.17377L4.56714 3.17676L4.56311 3.17377L4.58411 3.12576C4.58011 3.11976 4.58811 3.09477 4.60211 3.07477C4.61811 3.05877 4.63114 3.05176 4.65314 3.05176C4.69014 3.05176 4.72011 3.07776 4.72711 3.10376C4.73311 3.12476 4.72915 3.14375 4.71515 3.15775L4.69812 3.20377C4.68212 3.20477 4.66511 3.22577 4.64911 3.22577L4.68213 3.25076L4.67615 3.50476C4.68215 3.50076 4.76211 3.50474 4.81311 3.56274C4.82511 3.64274 4.87215 3.73476 4.87915 3.74576C4.88515 3.75176 4.90615 3.76875 4.92615 3.78275C4.99015 3.83375 5.00411 3.84475 4.99811 3.85175L4.97913 3.85574ZM4.72314 3.60776C4.64914 3.60776 4.56711 3.58775 4.53711 3.58075C4.50811 3.57175 4.46915 3.48076 4.46515 3.43576C4.43615 3.41276 4.43211 3.35976 4.44611 3.31976C4.43211 3.33976 4.41511 3.35376 4.38611 3.35376C4.37811 3.39176 4.31815 3.43877 4.31415 3.44077C4.31415 3.44077 4.30215 3.46374 4.30615 3.48074L4.33112 3.53375L4.28815 3.56375L4.24512 3.53177L4.27612 3.55374L4.30115 3.51877C4.29315 3.46477 4.30514 3.43777 4.30914 3.43677C4.30914 3.43477 4.36814 3.38775 4.37714 3.34875C4.42214 3.34475 4.44013 3.32076 4.45312 3.30276C4.45312 3.30476 4.45312 3.30576 4.45312 3.30576C4.45312 3.30276 4.45712 3.29876 4.46112 3.29376C4.45712 3.30176 4.4531 3.30776 4.4491 3.31476C4.4391 3.34976 4.43911 3.40776 4.47211 3.43176C4.47411 3.48076 4.5151 3.56575 4.5401 3.57275C4.5691 3.58175 4.67115 3.60574 4.72815 3.60574V3.60776C4.72815 3.60776 4.72714 3.60776 4.72314 3.60776Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_52"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask51_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M4.35547 3.12589C4.37147 3.09089 4.42145 3.09489 4.42145 3.09489C4.42145 3.09489 4.43945 3.04888 4.50745 3.07688C4.53245 3.05688 4.59747 3.08488 4.59747 3.08488C4.59747 3.08488 4.62443 3.05188 4.65643 3.05488C4.71943 3.06288 4.72844 3.11888 4.72644 3.12788C4.69344 3.13588 4.63046 3.10088 4.58746 3.11088C4.56246 3.12688 4.52245 3.13989 4.50745 3.16389C4.46445 3.16689 4.42147 3.12389 4.35547 3.12589Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_53"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask52_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M4.50031 3.16681C4.48231 3.16681 4.46531 3.15782 4.44531 3.15082C4.42231 3.13882 4.39428 3.12982 4.36328 3.12982C4.36328 3.12782 4.36328 3.12683 4.36328 3.12683C4.39428 3.12083 4.42231 3.13181 4.44531 3.14081C4.46831 3.15081 4.48631 3.15781 4.50031 3.15781V3.16281L4.5083 3.15781C4.5163 3.14081 4.54129 3.1308 4.56329 3.1188L4.60632 3.10382C4.62532 3.10382 4.64731 3.10981 4.66931 3.11581C4.68631 3.11981 4.70031 3.12582 4.71631 3.12582C4.70431 3.07882 4.69133 3.06281 4.65833 3.05981C4.62333 3.06381 4.60333 3.08582 4.60333 3.08582C4.59933 3.08882 4.56428 3.07281 4.53528 3.07281L4.47131 3.07083C4.43831 3.07083 4.42633 3.09583 4.42633 3.09583C4.40833 3.09883 4.3773 3.1018 4.3653 3.1228C4.3733 3.0918 4.40829 3.08981 4.42029 3.08981C4.42029 3.08981 4.45131 3.04681 4.51031 3.07181C4.56531 3.06381 4.60028 3.07782 4.60028 3.07782C4.60028 3.07782 4.62333 3.0498 4.65533 3.0498C4.69633 3.0538 4.71428 3.07183 4.72528 3.08783L4.73132 3.12781C4.70232 3.13181 4.6843 3.1268 4.6673 3.1228C4.6453 3.1168 4.62828 3.11282 4.60828 3.11282L4.56927 3.12683C4.54827 3.13583 4.52231 3.14882 4.51031 3.16382L4.50031 3.16681Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_54"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M4.48166 3.18425C4.49966 3.17425 4.53668 3.15824 4.56168 3.17924C4.58668 3.20524 4.62668 3.23326 4.62668 3.23326L4.67569 3.25325L4.69766 3.26625L4.68167 3.47826C4.63867 3.43426 4.59765 3.42725 4.57065 3.37425C4.55065 3.35425 4.56669 3.30027 4.53769 3.26427C4.50769 3.22827 4.47866 3.20425 4.48166 3.18425Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_55"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask54_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M4.68448 3.48608L4.67649 3.4801C4.66249 3.4611 4.64549 3.45109 4.62949 3.44009C4.60449 3.42309 4.58249 3.4071 4.56449 3.3761C4.55649 3.3661 4.55246 3.35109 4.55246 3.33209C4.54846 3.31009 4.54447 3.28509 4.53147 3.26709C4.48847 3.21809 4.4725 3.2011 4.4805 3.1821C4.4885 3.1761 4.50547 3.16309 4.53147 3.16309C4.53947 3.16909 4.54549 3.17409 4.55649 3.18109C4.51349 3.17309 4.49747 3.18108 4.48447 3.18808C4.48047 3.19808 4.49849 3.21509 4.51749 3.23709C4.55649 3.28309 4.55646 3.3071 4.56046 3.3331C4.56446 3.3501 4.56448 3.3631 4.57248 3.3721C4.59048 3.4041 4.61146 3.41811 4.63346 3.43311C4.64746 3.44311 4.66249 3.45508 4.67649 3.46808L4.68448 3.4021L4.68851 3.47708L4.68448 3.48608Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_56"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask55_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M4.5957 3.2435C4.5957 3.2435 4.62069 3.23949 4.62469 3.24549C4.63469 3.24849 4.64269 3.25148 4.64569 3.25748C4.65169 3.26148 4.65967 3.2655 4.65967 3.2725C4.67167 3.2755 4.67169 3.2905 4.67169 3.2905L4.6637 3.30249C4.6637 3.30249 4.65567 3.29249 4.65167 3.28449C4.64767 3.28049 4.63468 3.2785 4.63068 3.2695C4.62068 3.2685 4.61667 3.26449 4.61267 3.25449C4.60567 3.25649 4.5957 3.2435 4.5957 3.2435Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_57"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask56_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M4.80096 3.10435C4.78696 3.08835 4.76196 3.10234 4.76196 3.10234L4.69794 3.21336L4.67291 3.23735L4.66895 3.32435L4.68994 3.40636L4.68195 3.46834C4.68195 3.46834 4.71493 3.44034 4.71893 3.42134C4.72293 3.40434 4.70691 3.35234 4.70691 3.35234C4.70691 3.35234 4.68994 3.31936 4.71094 3.25636C4.73194 3.19636 4.78696 3.14535 4.80096 3.10435Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_58"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask57_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M4.67804 3.48059L4.68604 3.40659L4.66504 3.32657V3.23657L4.69806 3.21158L4.76208 3.10059L4.80109 3.10358C4.79709 3.12658 4.78308 3.14759 4.77008 3.16959C4.74908 3.19659 4.72909 3.22859 4.71509 3.26059C4.69409 3.31759 4.71106 3.35158 4.71106 3.35358C4.71106 3.35758 4.72708 3.40758 4.72308 3.42358C4.71908 3.44358 4.68604 3.47258 4.68604 3.47458L4.67804 3.48059ZM4.79706 3.10358L4.70306 3.21558L4.67206 3.32559L4.69403 3.40457L4.69006 3.45859C4.70006 3.44859 4.71509 3.43159 4.71509 3.42059C4.71909 3.40759 4.70706 3.36658 4.70306 3.35458C4.70306 3.35458 4.68103 3.31958 4.70703 3.25558C4.72303 3.22258 4.74008 3.19158 4.76208 3.16458C4.77708 3.14258 4.79106 3.12258 4.79706 3.10358Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_59"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask58_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M4.95711 3.20508C4.95711 3.20508 4.85913 3.35211 4.69313 3.40311C4.64813 3.41311 4.66414 3.2941 4.66414 3.2941L4.65212 3.29709C4.65212 3.29709 4.62517 3.41308 4.68917 3.41608C4.85517 3.38208 4.97817 3.20609 4.97817 3.20609L4.95711 3.20508Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_60"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask59_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M4.69022 3.41916L4.6572 3.40515C4.6322 3.37315 4.6492 3.29715 4.6492 3.29715C4.6532 3.30215 4.6532 3.30616 4.6572 3.31116C4.6532 3.33616 4.64719 3.38015 4.66519 3.40115L4.69022 3.41714V3.41116C4.80122 3.39016 4.89319 3.30314 4.94419 3.24814C4.90219 3.30314 4.80522 3.39716 4.69022 3.41916ZM4.69724 3.40515C4.68924 3.40315 4.68525 3.39815 4.68125 3.39215C4.85525 3.34415 4.95321 3.20315 4.95621 3.20215C4.96021 3.20415 4.96024 3.21315 4.95224 3.22415C4.91424 3.27015 4.82424 3.36615 4.69724 3.40515Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_61"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask60_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M5.02844 4.04065C5.02844 4.04065 5.01447 4.05165 4.99347 4.04065C4.98147 4.01565 4.95245 4.01364 4.95245 4.01364C4.95245 4.01364 4.93846 3.96065 4.90546 3.97665C4.90146 3.94965 4.87042 3.96264 4.87042 3.96264C4.87042 3.96264 4.87044 3.92463 4.83344 3.93063C4.84544 3.88463 4.78247 3.88763 4.78247 3.88763C4.78247 3.88763 4.78248 3.83765 4.68848 3.84665C4.88748 3.75765 5.04742 3.98764 5.04742 3.98764L5.02844 4.04065Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask61_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M4.98944 4.04411C4.97744 4.02111 4.95245 4.01811 4.95245 4.01811C4.94845 4.01311 4.93848 3.9851 4.92548 3.9781L4.91748 3.98209L4.86646 3.96211L4.85846 3.9651L4.82947 3.92909C4.81547 3.88909 4.78247 3.89011 4.78247 3.89011C4.74947 3.85211 4.72748 3.84611 4.68848 3.85011C4.88748 3.75311 5.04744 3.98209 5.04944 3.98509C5.05344 3.99109 4.93443 3.83009 4.78143 3.83009C4.75243 3.83009 4.72447 3.83511 4.69147 3.85111C4.72647 3.83911 4.75142 3.84509 4.77142 3.86009C4.78142 3.88509 4.81846 3.8821 4.83246 3.9011L4.89642 3.96009C4.94542 3.98009 4.95544 4.01111 4.95544 4.01411C4.95544 4.01211 4.98446 4.0151 4.99646 4.0391L5.03143 4.04609H4.98944V4.04411Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_63"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask62_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M5.12476 4.06055C5.12476 4.06055 5.16775 4.11154 5.19275 4.11154C5.21775 4.11154 5.21777 4.06155 5.21777 4.06155C5.21777 4.06155 5.22577 4.08355 5.23877 4.07755C5.23877 4.09355 5.25275 4.09854 5.25275 4.09854C5.25275 4.09854 5.20973 4.19454 5.09473 4.10254L5.12476 4.06055Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask63_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M5.18481 4.14462C5.15981 4.14462 5.12782 4.13162 5.09082 4.10562C5.13782 4.13162 5.17484 4.14461 5.20184 4.13461C5.23484 4.12561 5.25079 4.0966 5.25079 4.0946L5.2218 4.06561C5.2218 4.07861 5.21781 4.11661 5.19281 4.11661C5.16781 4.11461 5.12779 4.0686 5.12079 4.0636L5.12885 4.05762C5.13885 4.07062 5.18579 4.0996 5.19379 4.1076C5.20779 4.1076 5.21484 4.07461 5.21484 4.06161L5.22284 4.0636L5.21881 4.06161H5.22681C5.22681 4.06161 5.22684 4.06361 5.22284 4.06561L5.25781 4.0976C5.25781 4.1006 5.24382 4.13361 5.20282 4.14261C5.19682 4.14461 5.19281 4.14462 5.18481 4.14462Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_65"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask64_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M4.76576 4.0784L4.74776 4.14639C4.74776 4.14639 4.72877 4.16439 4.73177 4.16739C4.73977 4.17139 4.77278 4.1604 4.77278 4.1604C4.77278 4.1604 4.82378 4.1544 4.83778 4.1394C4.84778 4.1634 4.87477 4.1644 4.87477 4.1644C4.87477 4.1644 4.87474 4.15441 4.87074 4.14841C4.88474 4.15041 4.8918 4.14639 4.8918 4.14639C4.8918 4.14639 4.89774 4.12839 4.88374 4.12039C4.88774 4.10639 4.89177 4.0954 4.86977 4.0954C4.84677 4.1154 4.80378 4.1374 4.79378 4.1304C4.78178 4.1214 4.83677 4.09841 4.82277 4.06641L4.76576 4.0784Z",
    fill: "#91857C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_66"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask65_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_11472_49435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M4.72852 4.17215L4.76154 4.07715L4.76953 4.07916L4.75049 4.14615C4.78349 4.15515 4.8285 4.14814 4.8385 4.13614L4.86749 4.16016L4.88153 4.12314L4.89752 4.15115C4.88552 4.15815 4.8795 4.16015 4.8725 4.16315L4.87653 4.16516L4.86853 4.16415C4.84753 4.16015 4.84354 4.15514 4.83954 4.14114C4.82954 4.15914 4.77854 4.16516 4.77454 4.16516L4.72852 4.17215Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_67"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask66_11472_49435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000128460334932383214060000014806294201595235507__64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M34.1919 0.244141H0.628906V19.8232H34.1919V0.244141Z",
    fill: "white"
  })))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_11472_49435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M3.73219 3.9212L3.79622 3.90521L3.78822 3.87421C3.78822 3.86721 3.78218 3.86122 3.78218 3.85922C3.77418 3.85622 3.77018 3.8562 3.76118 3.8562V3.8522L3.8202 3.83722V3.8432C3.8122 3.8452 3.80821 3.84621 3.80421 3.84921C3.80021 3.85121 3.80018 3.85522 3.80018 3.85822C3.79618 3.86122 3.79618 3.86622 3.80018 3.87122L3.80818 3.90222L3.8592 3.88922C3.8672 3.88722 3.87321 3.88621 3.87721 3.88321C3.87721 3.88321 3.87718 3.88023 3.88118 3.87723C3.88118 3.87223 3.88118 3.86923 3.88118 3.86423L3.87721 3.85822L3.8852 3.85721L3.90217 3.92822L3.89418 3.93021V3.92322C3.89018 3.91722 3.89017 3.91121 3.88417 3.90921C3.88017 3.90821 3.87222 3.90822 3.86622 3.91122L3.75721 3.93723C3.74521 3.93823 3.74119 3.94121 3.73719 3.94321C3.73719 3.94321 3.73718 3.94623 3.73518 3.95023C3.73518 3.95223 3.73518 3.95821 3.73518 3.96021L3.73719 3.96722L3.73121 3.97021L3.70222 3.84421L3.73719 3.83221V3.83621C3.73119 3.84221 3.72722 3.84522 3.72322 3.85022C3.71922 3.85322 3.71919 3.85821 3.71919 3.86221C3.71719 3.86621 3.71919 3.8742 3.71919 3.8822L3.73219 3.9212ZM3.6902 3.62222C3.6902 3.60022 3.70019 3.58121 3.71919 3.56421C3.73719 3.55021 3.75821 3.54321 3.78321 3.54321C3.80821 3.54521 3.83022 3.55523 3.84822 3.57123C3.86422 3.58923 3.8712 3.6092 3.8672 3.6322C3.8672 3.6562 3.85522 3.6772 3.84022 3.6922C3.82322 3.7072 3.80117 3.71323 3.77217 3.71323C3.74717 3.71123 3.72517 3.70021 3.70717 3.68021C3.69117 3.66421 3.6852 3.64422 3.6902 3.62222ZM3.69917 3.62421C3.69517 3.64021 3.70322 3.65321 3.71522 3.66321C3.72922 3.67521 3.74617 3.6832 3.77217 3.6842C3.80517 3.6862 3.82722 3.6812 3.84022 3.6712C3.85222 3.6622 3.86018 3.64922 3.86018 3.63422C3.86018 3.61822 3.85619 3.6042 3.84419 3.5932C3.83019 3.5812 3.81321 3.57521 3.78321 3.57321C3.75421 3.57221 3.73219 3.57622 3.71919 3.58722C3.70319 3.59622 3.69917 3.60721 3.69917 3.62421ZM3.94917 3.31021L3.93123 3.3522L3.83717 3.37921C3.83317 3.38121 3.8332 3.38622 3.8332 3.38922L3.82917 3.39221V3.39423L3.8722 3.41321C3.8842 3.41721 3.8902 3.41821 3.8932 3.41721C3.8972 3.41621 3.90122 3.41021 3.90522 3.40521L3.90919 3.40021L3.91322 3.40121L3.8882 3.4682L3.8802 3.46722L3.88417 3.46121C3.88817 3.45421 3.88817 3.44921 3.88417 3.44421C3.88017 3.44121 3.87222 3.4392 3.86622 3.4342L3.76118 3.3952C3.75318 3.3912 3.74522 3.3902 3.74122 3.3912C3.73722 3.3932 3.73521 3.39721 3.73121 3.40421L3.72718 3.40921L3.72322 3.40622L3.74421 3.34921C3.75221 3.33021 3.76017 3.32022 3.76417 3.31122C3.77017 3.30422 3.77817 3.30023 3.78517 3.29523C3.79517 3.29223 3.80622 3.29221 3.81422 3.29721C3.82422 3.30021 3.83222 3.30622 3.83522 3.31522C3.83722 3.32522 3.84117 3.33821 3.83717 3.35321L3.89619 3.33621C3.91219 3.33421 3.92118 3.32922 3.92518 3.32422C3.93318 3.31922 3.93722 3.3142 3.93922 3.3042L3.94917 3.31021ZM3.82222 3.39322V3.39023C3.82622 3.38823 3.82618 3.38721 3.82618 3.38721C3.83018 3.37021 3.83018 3.35821 3.82618 3.34921C3.82618 3.33821 3.81618 3.33121 3.80818 3.32721C3.79218 3.32221 3.78722 3.32221 3.77522 3.32721C3.76922 3.33121 3.76121 3.33921 3.75721 3.34921C3.75721 3.35321 3.75319 3.35923 3.75319 3.36823L3.82222 3.39322ZM4.1902 2.81921L4.22322 2.86322L4.21919 2.86621C4.20719 2.85721 4.19617 2.85122 4.18617 2.85022C4.17417 2.84622 4.16121 2.85022 4.14521 2.85922C4.12821 2.87022 4.11818 2.8862 4.11818 2.9082C4.11818 2.9252 4.12418 2.94221 4.13618 2.96021C4.14418 2.97221 4.1532 2.98322 4.1692 2.99222C4.1832 3.00122 4.19417 3.0032 4.20417 3.0032C4.22017 3.0032 4.22919 3.0012 4.23719 2.9942C4.24519 2.9922 4.24717 2.98522 4.25117 2.98322C4.25517 2.97822 4.2592 2.97122 4.2632 2.96722L4.2342 2.92422C4.2302 2.91722 4.22619 2.91222 4.22419 2.91122C4.22019 2.90922 4.2202 2.90921 4.2162 2.90921C4.2122 2.90921 4.20821 2.91222 4.20021 2.91422V2.9122L4.2552 2.87521L4.25917 2.88022L4.2552 2.88123C4.2472 2.88423 4.2472 2.8892 4.2472 2.8952C4.2472 2.8982 4.2512 2.9042 4.2552 2.9122L4.28419 2.95621C4.28019 2.96421 4.27419 2.97522 4.26619 2.98022C4.26219 2.98922 4.25021 2.99423 4.24421 3.00223C4.21521 3.02023 4.18517 3.02421 4.16017 3.01721C4.14217 3.01121 4.12317 2.99822 4.11317 2.98022C4.10517 2.96822 4.09718 2.95421 4.09718 2.93921C4.09318 2.91921 4.09718 2.90221 4.10518 2.88721C4.11318 2.87321 4.1222 2.86222 4.1382 2.85422C4.1442 2.84922 4.14817 2.84721 4.15217 2.84521C4.15617 2.84221 4.1682 2.84123 4.1772 2.83823C4.1812 2.83723 4.18519 2.83621 4.18519 2.83621C4.18519 2.83621 4.18522 2.83321 4.18922 2.83121C4.18922 2.82821 4.18519 2.8262 4.18519 2.8222L4.1902 2.81921ZM4.46919 2.84021L4.40217 2.85822L4.39821 2.88721C4.39821 2.89421 4.39821 2.89922 4.39821 2.90222C4.39821 2.90522 4.4022 2.90723 4.4062 2.90723C4.4102 2.90923 4.41419 2.90923 4.42219 2.90723L4.42421 2.91321L4.37519 2.92621L4.37117 2.92322C4.37717 2.91922 4.3812 2.91522 4.3852 2.91422C4.3852 2.90922 4.3892 2.8992 4.3932 2.8862L4.41517 2.7352L4.4192 2.73221L4.5132 2.85522C4.5212 2.86522 4.5272 2.87221 4.5312 2.87521C4.5352 2.87621 4.54321 2.87822 4.54921 2.87622V2.88022L4.48518 2.8992V2.89423C4.49318 2.89223 4.49722 2.8892 4.49922 2.8862C4.49922 2.8842 4.49922 2.8812 4.49922 2.8782C4.49922 2.8752 4.49721 2.86921 4.48921 2.86221L4.46919 2.84021ZM4.46522 2.83121L4.41822 2.77121L4.4062 2.84622L4.46522 2.83121ZM4.76918 2.83121H4.77321L4.75422 2.8782L4.62519 2.8732V2.86722L4.63118 2.86823C4.63918 2.86823 4.64317 2.86621 4.64717 2.86121C4.64917 2.85921 4.64918 2.85322 4.64918 2.84122L4.65321 2.7312C4.65321 2.7202 4.65321 2.71121 4.65321 2.71121C4.64921 2.70621 4.64317 2.70522 4.63917 2.70322H4.62721L4.63118 2.69922L4.70717 2.7012V2.70721C4.69917 2.70621 4.6932 2.70723 4.6902 2.70923C4.6862 2.71123 4.6822 2.71221 4.6822 2.71521C4.6782 2.71921 4.67817 2.7242 4.67817 2.7352L4.67622 2.84421C4.67622 2.85121 4.67622 2.85522 4.67622 2.85922C4.67822 2.85922 4.67817 2.86121 4.67817 2.86121C4.68217 2.86321 4.69021 2.86323 4.70021 2.86423H4.7162C4.7282 2.86423 4.73422 2.86421 4.74122 2.86221C4.74522 2.86121 4.7512 2.85921 4.7552 2.85321C4.7622 2.84921 4.76618 2.84121 4.76918 2.83121ZM5.00019 2.89221L5.00422 2.89621L4.97322 2.9342L4.8462 2.89221L4.84822 2.88821L4.85621 2.89023C4.86421 2.89223 4.86819 2.89221 4.87519 2.88821C4.87519 2.88821 4.87918 2.88121 4.88118 2.87021L4.91822 2.76523C4.92222 2.75323 4.92222 2.74921 4.91822 2.74521C4.91822 2.74021 4.9142 2.7352 4.9062 2.7352L4.89821 2.73322L4.90217 2.7272L4.97621 2.75223V2.7572C4.96421 2.7532 4.9562 2.7522 4.9532 2.7532C4.9492 2.7532 4.94722 2.7542 4.94722 2.7572C4.94722 2.7592 4.94322 2.76521 4.93922 2.77621L4.9062 2.87921C4.9022 2.88621 4.89817 2.89123 4.90217 2.89423C4.90217 2.89723 4.9022 2.8992 4.9062 2.8992C4.9062 2.9012 4.91418 2.90423 4.92518 2.90723L4.93519 2.9122C4.94719 2.9152 4.95622 2.91721 4.96022 2.91721C4.96822 2.91621 4.97222 2.9152 4.97822 2.9122C4.98622 2.9062 4.99019 2.90121 5.00019 2.89221ZM5.18519 2.98923L5.1302 2.95221L5.10518 2.9682C5.09918 2.9702 5.0952 2.97521 5.0912 2.97821C5.0912 2.97821 5.0912 2.98122 5.0912 2.98422C5.0912 2.98822 5.09521 2.99321 5.10121 2.99921L5.09919 3.00223L5.05421 2.97021L5.05818 2.96521C5.06218 2.96921 5.07017 2.97122 5.07417 2.97122C5.08017 2.97022 5.08819 2.96522 5.09919 2.95822L5.23018 2.8782L5.23219 2.88022L5.20118 3.03223C5.19718 3.04423 5.19722 3.05223 5.19722 3.05823C5.20122 3.06323 5.20317 3.0682 5.20717 3.0722L5.2032 3.07822L5.15022 3.0372L5.15217 3.03421C5.16017 3.03721 5.16422 3.03922 5.16822 3.03922C5.16822 3.03922 5.17222 3.03722 5.17622 3.03522C5.17622 3.03122 5.18019 3.02621 5.18019 3.01721L5.18519 2.98923ZM5.18519 2.97922L5.2032 2.90622L5.13917 2.94623L5.18519 2.97922ZM5.3932 3.01923L5.42219 3.05722L5.38319 3.21921L5.46119 3.1582C5.46919 3.1512 5.47322 3.14622 5.47322 3.14322C5.47722 3.13922 5.47319 3.13223 5.46919 3.12723L5.46522 3.1232L5.46919 3.12122L5.50422 3.16821L5.50221 3.17221L5.49818 3.16721C5.49418 3.16221 5.49019 3.15723 5.48219 3.15723C5.48019 3.15823 5.47618 3.16221 5.46418 3.16721L5.34919 3.25223V3.25021L5.3882 3.0762L5.30421 3.13922C5.29421 3.14622 5.29017 3.15123 5.29017 3.15323C5.28617 3.15923 5.2902 3.16522 5.2942 3.16922L5.29817 3.17422L5.2942 3.1792L5.26118 3.1282V3.12622L5.26918 3.13123C5.27318 3.13623 5.2772 3.14023 5.2812 3.14023C5.2832 3.14023 5.29121 3.13623 5.29921 3.13123L5.39717 3.06021C5.39717 3.05221 5.39717 3.04721 5.39717 3.04321C5.39717 3.04021 5.3972 3.03521 5.3932 3.03021C5.3932 3.02821 5.38917 3.02522 5.38917 3.02222L5.3932 3.01923ZM5.6092 3.41922L5.57417 3.43622L5.5702 3.43121C5.5782 3.42721 5.58418 3.4242 5.58418 3.4212C5.58818 3.4172 5.59217 3.41323 5.59217 3.40723C5.59217 3.40323 5.59217 3.3982 5.59217 3.3912L5.58217 3.36722L5.45717 3.4122C5.44717 3.4162 5.4402 3.4182 5.4402 3.4212C5.4362 3.4272 5.4362 3.4312 5.4402 3.4382V3.44321L5.43617 3.44623L5.41517 3.37723V3.37622L5.4192 3.38123C5.4232 3.38823 5.42723 3.39323 5.43123 3.39423C5.43323 3.39523 5.44117 3.3942 5.44917 3.3912L5.57618 3.34622L5.56819 3.32822C5.56419 3.31822 5.56019 3.31421 5.56019 3.31421C5.55619 3.30721 5.55422 3.30422 5.54622 3.30322C5.54222 3.30022 5.53421 3.3032 5.52821 3.3042L5.52418 3.3002L5.56318 3.2872L5.6092 3.41922ZM5.47322 3.72821V3.68121L5.55317 3.61823C5.54917 3.61323 5.54921 3.6102 5.54921 3.6062V3.60422C5.54921 3.60422 5.54921 3.60121 5.54921 3.59921L5.49818 3.6022C5.48618 3.6022 5.48118 3.6042 5.47718 3.6062C5.47718 3.6102 5.47322 3.61622 5.47322 3.62222V3.62921H5.46919L5.46522 3.55621L5.47322 3.5542V3.56223C5.47322 3.56823 5.47318 3.5732 5.47718 3.5762C5.48318 3.5792 5.48718 3.57922 5.49818 3.57922L5.60621 3.57321C5.61821 3.57221 5.62522 3.57021 5.62922 3.56821C5.63322 3.56521 5.63319 3.56022 5.63319 3.55322V3.5462H5.6352L5.63917 3.60721C5.63917 3.62621 5.63917 3.63922 5.63917 3.64822C5.63517 3.65822 5.63319 3.66722 5.62519 3.67322C5.61719 3.67922 5.6092 3.68323 5.6042 3.68323C5.5922 3.68423 5.58221 3.6812 5.57521 3.6752C5.56321 3.6682 5.55917 3.65722 5.55317 3.64322L5.50422 3.68121C5.49422 3.69021 5.49017 3.69822 5.48317 3.70322C5.48317 3.70822 5.48121 3.71723 5.48121 3.72623L5.47322 3.72821ZM5.55519 3.59921V3.60321V3.60721C5.55519 3.62321 5.56318 3.63423 5.57118 3.64423C5.57918 3.65223 5.58517 3.65621 5.60017 3.65421C5.60617 3.65421 5.61817 3.64922 5.62117 3.64322C5.62917 3.63422 5.63319 3.62622 5.63319 3.61722C5.63319 3.61122 5.62922 3.60422 5.62922 3.59622L5.55519 3.59921ZM5.6042 3.95422L5.58821 4.01321L5.58418 4.01221V4.00922C5.58418 4.00722 5.58418 4.0032 5.58418 3.9982C5.58418 3.9942 5.58217 3.99022 5.58217 3.98422C5.57817 3.98122 5.57017 3.97522 5.56617 3.96722L5.51118 3.90921L5.47218 3.89822C5.46018 3.89622 5.45221 3.89621 5.45021 3.89621C5.44621 3.89921 5.44221 3.90422 5.44221 3.91022L5.43818 3.9162L5.43422 3.91522L5.45222 3.84521H5.45619V3.8522C5.45219 3.8592 5.45222 3.86521 5.46022 3.87021C5.46022 3.87021 5.46821 3.87422 5.47621 3.87622L5.51521 3.88721L5.59919 3.8602C5.60519 3.8572 5.6132 3.85521 5.6172 3.85321C5.6172 3.85321 5.62122 3.84821 5.62922 3.84421C5.62922 3.84221 5.62922 3.83823 5.62922 3.83423L5.6352 3.83823L5.6172 3.90723H5.6092V3.90222C5.6132 3.89922 5.6132 3.89521 5.6092 3.89221C5.6092 3.88821 5.60918 3.88622 5.60518 3.88422C5.60318 3.88322 5.59917 3.88421 5.58717 3.88821L5.52217 3.90622L5.5652 3.95322C5.5732 3.96022 5.5812 3.96522 5.5832 3.96622C5.5832 3.96622 5.5872 3.96622 5.5912 3.96622C5.5912 3.96622 5.59517 3.96421 5.59517 3.96121C5.59917 3.96021 5.59919 3.95722 5.59919 3.95322H5.6042V3.95422Z",
    fill: "black"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalta);
export default __webpack_public_path__ + "static/media/MALTA.abf12a166c6e636c53eed98aed17ba78.svg";
export { ForwardRef as ReactComponent };